import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { routesConfig } from "./routesConfig";
import { PublicRoute } from "./PublicRoute";

import Layout from "@components/Layout/Layout";
import Splash from "modules/Splash/Splash";

const AppRouter: React.FC = () => {
	return (
		<Router>
			<Suspense fallback={<Splash />}>
				<Routes>
					{/* Render both public and private routes dynamically */}
					{routesConfig.map(({ path, component: Component, type }) => {
						const RouteWrapper = () => (
							<Layout>
								<Component />
							</Layout>
						);

						if (type === "public") {
							return (
								<Route
									key={path}
									path={path}
									element={<PublicRoute component={RouteWrapper} />}
								/>
							);
						}

						return null;
					})}
				</Routes>
			</Suspense>
		</Router>
	);
};

export default AppRouter;
